import React from "react";
import classNames from "classnames/bind";
import style from "./style.module.css";
import { Link } from "react-router-dom";
import { NavItem, NavPath } from "../../enums/nav";

export interface ITopNavProps {
    selected: string;
    handleNavClick: (navItem: string) => void;
}

export function TopNav(props: ITopNavProps) {
    const navItems = [
        {
            label: NavItem.SOLUTION,
            path: NavPath.HOME
        },
        {
            label: NavItem.DESIGN,
            path: NavPath.DESIGN
        },
        {
            label: NavItem.RESEARCH,
            path: NavPath.RESEARCH
        },
        {
            label: NavItem.GUIDELINES,
            path: NavPath.GUIDELINES
        },
        {
            label: NavItem.ABOUT,
            path: NavPath.ABOUT
        }
    ];

    const boundClasses = classNames.bind(style);
    const handleNavClick = (navItem: string) => {
        return () => {
            props.handleNavClick(navItem);
        }
    }

    return (
        <header className={style.header}>
            <Link
                to="/"
                className={style.navItem}
                onClick={handleNavClick(NavPath.HOME)}
            >
                Team TMI
            </Link>
            <nav className={style.nav}>
                {
                    navItems.map(({ label, path }) => {
                        const className = boundClasses(
                            { [style.navItem]: true },
                            { [style.selected]: props.selected === path }
                        )
                        return <Link
                            key={label}
                            className={className}
                            to={path}
                            onClick={handleNavClick(path)}
                        >
                            {label}
                        </Link>;
                    })
                }
                <a
                    className={style.navItem}
                    href="https://medium.com/mhci-capstone"
                    target="_blank"
                    rel="noreferrer"
                >{NavItem.BLOG}</a>

            </nav>
        </header>
    )
}